import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { EmailRecord, GiftCardStyle, PromoData } from 'types';

export type GiftCardsStore = {
  isLoading: boolean;
  isLoadingPreview: boolean;
  isDeleteLoading: boolean;
  isLoadingCardOrder: boolean;
  errorMsg: string;
  giftCardStyles: GiftCardStyle[];
  recipientEmails: EmailRecord[];
  promo: PromoData | null;
};

const initialState: GiftCardsStore = {
  isLoading: false,
  isLoadingPreview: false,
  isDeleteLoading: false,
  isLoadingCardOrder: false,
  errorMsg: '',
  giftCardStyles: [],
  recipientEmails: [],
  promo: null
};

export const giftCardsSlice = createSlice({
  name: 'giftCards',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setIsLoadingPreview: (state, action: PayloadAction<boolean>) => {
      state.isLoadingPreview = action.payload;
    },
    setIsDeleteLoading: (state, action: PayloadAction<boolean>) => {
      state.isDeleteLoading = action.payload;
    },
    setIsLoadingCardOrder: (state, action: PayloadAction<boolean>) => {
      state.isLoadingCardOrder = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.errorMsg = action.payload;
    },
    setGiftCardStyles: (state, action: PayloadAction<GiftCardStyle[]>) => {
      state.giftCardStyles = action.payload;
    },
    setRecipientEmails: (state, action: PayloadAction<EmailRecord[]>) => {
      state.recipientEmails = action.payload;
    },
    setPromo: (state, action: PayloadAction<PromoData>) => {
      state.promo = action.payload;
    }
  }
});

export const {
  setIsLoading,
  setIsDeleteLoading,
  setIsLoadingPreview,
  setError,
  setGiftCardStyles,
  setIsLoadingCardOrder,
  setRecipientEmails,
  setPromo
} = giftCardsSlice.actions;

export default giftCardsSlice.reducer;
